export const WEB_SHARE_TARGET_DATA_IDB_KEY = 'web-share-data'
